module.exports = __webpack_public_path__ + "img/android-phone.bb59a136.png";